import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { Card, Form, Button, Alert, Container, Spinner } from 'react-bootstrap';

const Register = ({ onLogin, setCurrentView }) => {
    const [formData, setFormData] = useState({
        full_name: '', email: '', password: '', confirmPassword: ''
    });
    const [showOtpView, setShowOtpView] = useState(false);
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    const { full_name, email, password, confirmPassword } = formData;
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    // Tự động xóa thông báo lỗi sau 5 giây
    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => setError(null), 5000);
            return () => clearTimeout(timer);
        }
    }, [error]);

    const handleRegister = async (e) => {
        e.preventDefault();
        setError(null);
        setMessage(null);
        
        if (password !== confirmPassword) return setError("Mật khẩu xác nhận không khớp.");
        setLoading(true);

        try {
            // --- [LOGIC TRUY VẾT ĐẠI LÝ ĐA TẦNG] ---
            const urlParams = new URLSearchParams(window.location.search);
            
            // Ưu tiên 1: Mã lưu từ Landing (referred_by_agency)
            // Ưu tiên 2: Mã trên URL (?ref=...)
            // Ưu tiên 3: Mã trên URL cũ (?agency=...)
            const agencySlug = localStorage.getItem('referred_by_agency') || 
                               urlParams.get('ref') || 
                               urlParams.get('agency');

            console.log("🔗 Đang đăng ký với mã đại lý:", agencySlug);

            const res = await api.post('/api/auth/register', { 
                full_name, 
                email: email.trim().toLowerCase(), 
                password,
                agencySlug: agencySlug // Gửi lên backend để gán referredBy
            });

            if (res.data.success) {
                setMessage(res.data.message);
                
                // Đăng ký bước đầu thành công -> Xóa mã đại lý trong máy để dọn dẹp
                localStorage.removeItem('referred_by_agency');

                if (res.data.requiresVerification) {
                    setShowOtpView(true);
                } else {
                    setTimeout(() => setCurrentView('login'), 2500);
                }
            }
        } catch (err) {
            setError(err.response?.data?.message || "Đăng ký thất bại. Vui lòng thử lại.");
        } finally { setLoading(false); }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const res = await api.post('/auth/verify-otp', { 
                email: email.trim().toLowerCase(), 
                otp 
            });
            if (res.data.success) {
                setMessage("Xác thực thành công! Đang chuyển hướng đến đăng nhập...");
                setTimeout(() => setCurrentView('login'), 2000);
            }
        } catch (err) { 
            setError(err.response?.data?.message || "Mã OTP không chính xác hoặc đã hết hạn."); 
        } finally { setLoading(false); }
    };
    const handleResendOtp = async () => {
    setLoading(true);
    try {
        await api.post('/api/auth/resend-otp', { email: email.trim().toLowerCase() });
        setMessage("Mã OTP mới đã được gửi lại vào email của bạn.");
    } catch (err) {
        setError("Không thể gửi lại mã. Vui lòng thử lại sau.");
    } finally {
        setLoading(false);
    }
};
    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
            <Card className="shadow-lg border-0 animate__animated animate__fadeIn" style={{ maxWidth: '450px', width: '100%', borderRadius: '15px', background: '#fff' }}>
                <div className="text-center p-4" style={{ background: '#111827', borderBottom: '4px solid #ccac00', borderRadius: '15px 15px 0 0' }}>
                    <h3 className="text-warning fw-bold text-uppercase">{showOtpView ? 'XÁC THỰC OTP' : 'ĐĂNG KÝ TÀI KHOẢN'}</h3>
                    <p className="text-light small mb-0 opacity-75">Hệ thống giao dịch tự động NeXBot</p>
                </div>
                <Card.Body className="p-4">
                    {error && <Alert variant="danger" className="py-2 small fw-bold">{error}</Alert>}
                    {message && <Alert variant="success" className="py-2 small fw-bold">{message}</Alert>}
                    
                    {!showOtpView ? (
                        <Form onSubmit={handleRegister}>
                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold text-secondary text-uppercase">Họ và tên</Form.Label>
                                <Form.Control name="full_name" placeholder="Nhập họ tên của bạn" onChange={onChange} required disabled={loading} className="py-2 border-secondary border-opacity-25" />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold text-secondary text-uppercase">Email</Form.Label>
                                <Form.Control type="email" name="email" placeholder="Ví dụ: nexbot@gmail.com" onChange={onChange} required disabled={loading} className="py-2 border-secondary border-opacity-25" />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold text-secondary text-uppercase">Mật khẩu</Form.Label>
                                <Form.Control type="password" name="password" placeholder="Mật khẩu từ 6 ký tự" onChange={onChange} required disabled={loading} className="py-2 border-secondary border-opacity-25" />
                            </Form.Group>
                            <Form.Group className="mb-4">
                                <Form.Label className="small fw-bold text-secondary text-uppercase">Xác nhận mật khẩu</Form.Label>
                                <Form.Control type="password" name="confirmPassword" placeholder="Nhập lại mật khẩu" onChange={onChange} required disabled={loading} className="py-2 border-secondary border-opacity-25" />
                            </Form.Group>
                            <Button variant="dark" type="submit" className="w-100 text-warning fw-bold py-3 shadow-sm" disabled={loading} style={{ letterSpacing: '1px' }}>
                                {loading ? <Spinner animation="border" size="sm" /> : 'KHỞI TẠO TÀI KHOẢN'}
                            </Button>
                        </Form>
                    ) : (
                        <Form onSubmit={handleVerifyOtp}>
                            <div className="text-center mb-3 small text-muted">
                                Mã 6 số đã được gửi vào email <b className="text-dark">{email}</b>. Vui lòng kiểm tra cả hộp thư Spam.
                            </div>
                            <Form.Control 
                                className="mb-4 text-center fs-2 fw-black border-warning" 
                                style={{ letterSpacing: '8px' }}
                                value={otp} 
                                onChange={e => setOtp(e.target.value)} 
                                placeholder="000000" 
                                maxLength={6}
                                required 
                                disabled={loading}
                            />
                            <Button variant="warning" type="submit" className="w-100 fw-bold py-3 shadow-md" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : 'XÁC THỰC NGAY'}
                            </Button>
                            {/* Thêm nút này dưới nút "XÁC THỰC NGAY" */}
<Button variant="link" size="sm" onClick={handleResendOtp} className="w-100 mt-2 text-muted" disabled={loading}>
    Không nhận được mã? Gửi lại OTP
</Button>
                        </Form>
                    )}
                    <div className="text-center mt-4 border-top pt-3">
                        <span className="small text-muted">Bạn đã có tài khoản?</span>
                        <Button variant="link" onClick={() => setCurrentView('login')} className="text-decoration-none small p-0 ms-1 fw-bold text-dark">Đăng nhập</Button>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Register;